// Fecha: 11-07-2024


import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewLstResultadoTropa = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'lst_resultado_tropa',
        name: 'lst_resultado_tropa',
        component: ViewLstResultadoTropa,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
